export default "__VITE_ASSET__BlpZkI8T__"